<template>
	<div class="ui inline search compact dropdown manager-season-picker">
		<input type="hidden" :value="season.id" />
		<div class="text"></div>
		<i class="dropdown icon" />
		<div class="menu" style="z-index: 10000;">
			<div class="item" :data-value="season.id" v-for="season in seasons" :key="season.id">
				{{ season.name }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['season', 'seasons'],
	mounted: function() {
		var me = this;
		$(this.$el).dropdown({
			forceSelection: false,
			fullTextSearch: 'exact',
			match: 'text',
			onChange: function (value, text, elem) {
				var season = me.seasons.filter(function(season) {
					return season.id == value;
				})[0];

				$(me).find('input').blur();
				me.$emit('seasonChanged', season);
			}
		});
	}
};
</script>

<style scoped>
.manager-season-picker {
	white-space: nowrap;
}
</style>